import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { environment } from './../../../../../environments/environment';

@Injectable()
export class ProductCategoryEditService {
  private urlPrefix: string = environment.appUrl;
  constructor(
      private http: HttpClient
  ) { }

  edit(id, post): Observable<any> {
    const url = this.urlPrefix + 'product-cats/' + id ;
    return this.http
      .put(url, {
          name: post.name
      }, { observe: 'response' })
      .map(
        res => {
          if (res.status === 200) {
            return res.body;
          } else {
            return Observable.throw(null);
          }
        }
      )
      .catch(
        err => {
          return Observable.throw(err);
        }
      );
  }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/product-category/edit/edit.service.ts